const Queries = {
    GET_STORE_DETAILS_BY_STORE_ID: 'GetStoreDetailsByStoreId',
    GET_STORE_PRODCUTS: 'GetStoreProducts',
    GET_HOME_PAGE_PRODUCTS: 'GetHomePageProducts',
    GET_REGIONAL_ADS: 'GetRegionalAds',
    GET_VEHICLE_CARDS: 'GetVehicleCards',
    GET_HOME_FRESH_PRODUCTS: 'GetHomeFreshProducts',
};

export default Queries;
